export const FORMAT_CREATE_AT = 'HH:mm DD/MM/YYYY';

export const TYPE_VOLUME_SORT = {
  ALL: 'all',
  EQUAL_ZERO: 'equal_zero',
  GRETTER_THAN_ZERO: 'gretter_than_zero'
} as const;

export const DATA_VOLUME_SORT = [
  {
    value: 'all',
    text: 'Tất cả'
  },
  { value: 'equal_zero', text: 'Cổ phiếu đã bán' },
  {
    value: 'gretter_than_zero',
    text: 'Cổ phiếu đang khuyến nghị'
  }
] as const;
